const getUser = (state) => state.get('user');
const getUserId = (state) => getUser(state).get('id');

export const getIsLoggedUser = (state) => Boolean(getUserId(state));
